<template>

  <div class="Header cadfm-flexitem-fixed">
    <b-navbar v-if="isLogged" toggleable="sm" :type="s_skinVariant" :variant="s_skinVariant">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>


      <b-navbar-brand>
        <img v-if="s_skinVariant == 'dark'" src="/static/OMNYA-integration-platform-dark.svg">
        <img v-if="s_skinVariant == 'light'" src="/static/OMNYA-integration-platform-light.svg">

      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <!-- <router-link v-if="appConf.status.isPM" @click.native="reloadTable()" to="/Dashboard/DashboardWidgets"
            class="nav-link">{{lang["Dashboard"]}}</router-link>
          <router-link v-if="appConf.status.isPM" @click.native="reloadTable()" to="/PartManager/PartTable"
            class="nav-link">{{lang["Parts"]}}</router-link>
          <router-link v-if="appConf.status.isLM" @click.native="reloadTable()" to="/LibraryManager/LibraryTable"
            class="nav-link">{{lang["Libraries"]}}</router-link>
          <router-link v-if="appConf.status.isPRM" @click.native="reloadTable()" to="/ProjectManager/ProjectTable" class="nav-link">{{lang["Projects"]}}</router-link> -->
          <router-link @click.native="reloadTable()" to="/Dashboard/DashboardWidgets" class="nav-link">{{
            lang["Dashboard"] }}</router-link>
          <router-link @click.native="reloadTable()" to="/PartManager/PartTable" class="nav-link">{{ lang["Parts"]
            }}</router-link>
          <router-link @click.native="reloadTable()" to="/LibraryManager/LibraryTable" class="nav-link">{{
            lang["Libraries"] }}</router-link>
          <router-link @click.native="reloadTable()" to="/ProjectManager/ProjectTable" class="nav-link">{{
            lang["Projects"] }}</router-link>
          <router-link v-if="globalSettings.requests" @click.native="reloadTable()" to="/RequestManager/RequestTable" class="nav-link">{{
              lang["Requests"] }}</router-link>
          <router-link @click.native="reloadTable()" to="/Users/Main" class="nav-link">{{lang["Users"]}}</router-link>
          <router-link @click.native="reloadTable()" to="/Settings/Main"
            class="nav-link">{{lang["Settings"]}}</router-link>
          <router-link @click.native="reloadTable()" to="/About/Main" class="nav-link">{{ lang["About"] }}</router-link>



        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!-- <span v-if="true" class="license-info"> -->
          <div v-if="expiresDays <= 7" class="mb-1 license-info">
            <b-spinner type="grow" label="License" :variant="expiresDays<0?'danger':'warning'" small></b-spinner>
            <!-- </span> -->
            <span v-if="(expiresDays == 0 | expiresDays == 1) && expiresDays != null">{{ lang.label_license1 }} {{
              expiresDays }} {{
              lang.label_license2 }}</span>
            <span v-if="expiresDays > 1">{{ lang.label_license1 }} {{ expiresDays }} {{ lang.label_license3 }}</span>
            <span v-if="expiresDays < 0 || expiresDays == null">{{ lang.label_license4 }}</span>
          </div>
          <div class="mb-1 avatar">
            <b-avatar v-b-tooltip.hover.left :title="'login: ' + currentUser.login + ' role: ' + currentUser.role"
              v-if="currentUser.role=='Admin'" variant="danger" size="sm"></b-avatar>
            <b-avatar v-b-tooltip.hover.left :title="'login: ' + currentUser.login + ' role: ' + currentUser.role"
              v-if="currentUser.role!='Admin' && currentUser.role != 'Reader'" size="sm"></b-avatar>
            <b-avatar v-b-tooltip.hover.left :title="'login: ' + currentUser.login + ' role: ' + currentUser.role"
              v-if="currentUser.role == 'Reader'" variant="info" size="sm"></b-avatar>
            {{fullName}}
          </div>



          <!--<b-button v-b-tooltip.hover.left :title="lang.button_Settings" v-on:click="settings" size="sm" class="my-2 my-sm-0" type="submit">{{lang.button_Settings}}</b-button>-->
          <b-button v-b-tooltip.hover.left :title="lang.button_Logout" v-on:click="logout" :variant="variant" size="sm"
            class="my-2 my-sm-0" type="submit">{{lang.button_Logout}}</b-button>

        </b-navbar-nav>



      </b-collapse>
    </b-navbar>
    <b-navbar v-if="!isLogged" toggleable="md" :type="s_skinVariant" :variant="s_skinVariant">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>



      <b-navbar-brand>
        <img v-if="s_skinVariant == 'dark'" src="/static/OMNYA-integration-platform-dark.svg">
        <img v-if="s_skinVariant == 'light'" src="/static/OMNYA-integration-platform-light.svg">

      </b-navbar-brand>

      <!-- <b-navbar-nav class="ml-auto">
            <img v-if="s_skinVariant == 'dark'" src="/static/FlowCAD-Logo-dark.svg">
            <img v-if="s_skinVariant == 'light'" src="/static/FlowCAD-Logo-light.svg">
          </b-navbar-nav> -->

    </b-navbar>

    <!-- <SettingsComponent></SettingsComponent> -->
  </div>





</template>
<script>
  //import SettingsComponent from "@/components/shared/SettingsComponent"
  import { mapGetters } from 'vuex'

  export default {
    name: 'Header',
    components: {
      //SettingsComponent
    },
    data () {
      return {
        fullName: ""
      }
    },
    props: {
      lang: Object
    },
    computed: {
      ...mapGetters([
      'isLogged',
      //'isSettings',
      's_skinVariant',
      'appConf',
      'globalSettings'
      //'isPlugin'
      ]),
      currentUser(){
        return this.$store.getters.currentUser;
      },
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      },
      expiresDays() {
        

        if (this.appConf.status.expires != null) {

          const now = new Date();
          const oneDay = 1000 * 60 * 60 * 24;

          const endOfDate = new Date(this.appConf.status.expires)
          const diffInTime = endOfDate.getTime() - now.getTime();
          const diffInDays = Math.round(diffInTime / oneDay);
          return diffInDays;
        }


        return null;
      },
    },
    created(){
      this.getUser();    
    },
    updated() {

      this.getUser();
    },
    
    methods: {
      getUser(){
        let vue = this;

        const obj = {
          userId: this.currentUser.userId
        }
        
        this.$store.dispatch("u_getUser", obj)
        .then ((result) => {

          
          if (result.data != null){
            if (result.data.length > 0){
              vue.fullName = result.data[0].FirstName + " " + result.data[0].LastName;

              vue.$store.dispatch("setUserFullName", vue.fullName);
            }
          }
          
          
          

        })
      },
      logout(){
        this.$store.dispatch('logout');
      },
      reloadTable() {
        
        let reloadObj = {};
        if (this.$store.getters.sectionPrefix == "d") {

        }
        if (this.$store.getters.sectionPrefix == "pm") {
          this.$store.dispatch("deleteAllSelectedRows");
          reloadObj.status = true;
          reloadObj.name = "DataTableFilteredOnApiComponent";
          this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          this.$store.dispatch("deleteAllSelectedRows");
          reloadObj.status = true;
          reloadObj.name = "DataTableFilteredOnApiLibComponent";
          this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          this.$store.dispatch("deleteAllSelectedRows");
          reloadObj.status = true;
          reloadObj.name = "DataTableFilteredOnApiProjComponent";
          this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        }
        if (this.$store.getters.sectionPrefix == "u") {

        }
        if (this.$store.getters.sectionPrefix == "set") {

        }
        if (this.$store.getters.sectionPrefix == "about") {

        }
        
        this.$store.commit("RESETROUTINGDATA");
        
        this.$store.dispatch("setSaveStatus", false);
      }
    },
    watch: {
      currentUser: function(newVal, oldVal){
        
        this.login = newVal
      }
    }
  }
</script>
<style lang="scss">

  @import "./../scss/_theme.scss";

  .Header{

    .image-desc {
      font-size: 0.6rem;
      float:left;
      display: block;
    }
    .navbar-brand {
      margin-left: 1rem;
      
    }
    .navbar-brand img{
      height:38px;
      
    }
    img{
      margin-right: 0px;
      margin-left: 0px;
      height: 22px;
      display: block
    }
    button{
      margin-right: 10px;
    }

    .avatar{
      margin-right: 10px;
    }
    .license-info{
      margin-left: 10px;
      margin-right: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue